import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Modal } from 'bootstrap';
import { Data2Service } from '../../common/data2.service';
import { InfoboxService } from '../../common/infobox/infobox.service';
import { ExchangeRateService } from '@/event-business/exchange-rate.service';

@Component({
	selector: 'app-event-business-payments',
	templateUrl: './event-business-payments.component.html',
	styleUrls: ['./event-business-payments.component.css'],
})
export class EventBusinessPaymentsComponent implements OnChanges {
	@Input() issue: any;
	@Input() paymentMethods: Array<any> = [];
	@Input() companiesAccounts: Array<any> = [];
	@Input() currencies: Array<any> = [];
	@Output() closed = new EventEmitter();
	loading = false;
	paymentsYesNoQuestion: string = null;
	payments: Array<any> = [];
	rowToRemove;

	private readonly exchangeRateService = inject(ExchangeRateService);

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
	) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.issue && this.issue) {
			this.api.command('/eventBusinessPayments/', { cmd: 'payments', id: this.issue.id }, (result, error) => {
				this.payments = result.data;
				this.payments.forEach((payment) => {
					this.changeValue(payment.currency, payment.id);
				});
				this.loading = false;
				if (error) {
					return;
				}
			});
			this.dialogOpen();
		}
	}

	save(data) {
		data.editable = false;
		this.loading = true;
		if (data.id) {
			this.objectEdit(data);
			return;
		}
		this.objectAdd(data);
		return;
	}

	private objectAdd(data) {
		data.eventBusiness = this.issue.eventBusiness;
		data.eventBusinessIssue = this.issue.id;
		this.api.post('/eventBusinessPayments', data, (result, error) => {
			this.loading = false;
			if (error) {
				return;
			}
			return (data.id = result.data);
		});
	}

	private objectEdit(data) {
		this.api.put('/eventBusinessPayments/' + data.id + '/', data, (result, error) => {
			this.loading = false;
			if (error) {
				return;
			}
		});
	}

	addPos() {
		const data = {
			id: null,
			date: null,
			value: null,
			paymentMethod: null,
			description: null,
			currency: null,
			editable: true,
		};
		this.payments.push(data);
	}

	dialogOpen() {
		new Modal(document.getElementById('eventBusinessPaymentsModal')).show();
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('eventBusinessPaymentsModal'));
		if (!modal) {
			return;
		}
		modal.hide();
		this.closed.emit();
	}

	deleteAsk(data) {
		this.rowToRemove = data;
		this.dialogClose();
		this.deleteDialogOpen();
	}

	deleteConfirm() {
		this.deleteDialogClose();
		if (!this.rowToRemove.id) {
			this.removeRow(this.rowToRemove);
			return;
		}
		this.loading = true;
		this.api.del('/eventBusinessPayments/' + this.rowToRemove.id + '/', (result, error) => {
			this.loading = false;
			if (error) {
				return;
			}
			this.removeRow(this.rowToRemove);
		});
	}

	private removeRow(data) {
		this.payments = this.payments.filter((obj) => obj != data);
	}

	deleteDialogOpen(): void {
		new Modal(document.getElementById('eventBusinessPaymentsQuestion')).show();
	}

	deleteDialogClose(): void {
		this.dialogOpen();
		const modal = Modal.getInstance(document.getElementById('eventBusinessPaymentsQuestion'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	changeValue(currency: string, id: string): void {
		const currentRow = this.payments.find((row) => row.id === id);

		if (!currentRow) {
			this.infobox.error('Nie znaleziono wiersza o podanym ID');
			return;
		}

		this.exchangeRateService
			.calculateCurrency(currency, currentRow)
			.then((result) => this.updateRowValuePln(id, result));
	}

	private updateRowValuePln(id: string, valuePln: number | null): void {
		this.payments = this.payments.map((row) => (row.id === id ? { ...row, valuePln } : row));
	}
}
